import { typographyTokens } from '../../theme/typographyTokens';
import * as React from 'react';
import { Box, Link, Typography, useTheme } from '@mui/material';
const pjson = require('../../../../package.json');

const buildNumber = pjson.com_constellation.Build.BuildNumber;
const buildUrl = [
  pjson.com_constellation.Build.Repository.Uri.replace('ConstellationADO@', ''),
  'commit',
  pjson.com_constellation.Build.SourceVersion,
].join('/');

function Footer(props: any) {
  const theme = useTheme();
  return (
    <>
      <Box
        component="footer"
        sx={{
          marginLeft: 'auto',
          marginRight: 'auto',
          display: 'flex',
          alignItems: 'center',
          color: theme.palette.content.default,
          flexDirection: 'column',
          my: 3,
          width: '100%',
          fontSize: typographyTokens.fontSizes.xl,
        }}
      >
        <Typography sx={{ color: theme.palette.content.default }}>
          Version:{' '}
          <Link
            sx={{
              textDecoration: 'none',
              color: theme.palette.prime.blue,
              '&:hover': {
                color: theme.palette.primeAdditional.midBlue,
                textDecoration: 'underline',
              },
            }}
            href={buildUrl}
            target="_blank"
            rel="noopener">{buildNumber}</Link>
        </Typography>
      </Box>
    </>
  );
}

export default Footer;
